<script>
import { ValidationObserver } from 'vee-validate'
// import { services } from '@src/utils/common-services'
// eslint-disable-next-line no-unused-vars
import Autocomplete from 'vuejs-auto-complete'
import { appConfig } from '@src/app.config'

import { BIcon } from 'bootstrap-vue'
export default {
  components: { ValidationObserver, BIcon, Autocomplete },
  props: {
    user: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default() {
        return 'address'
      },
    },
    label: {
      type: String,
      default() {
        return 'Address'
      },
    },
    options: {
      type: Object,
      default() {
        return {}
      },
    },
    value: {
      type: Object,
      default() {
        return null
      },
    },
    api: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      form: [],
      address: {},
      savedData: [],
      storeData: {},

      showList: false,
      index: null,
      restrict: null,
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal && this.value !== null)
        if (Object.keys(this.value).length !== 0) {
          this.storeData = Object.assign({}, this.storeData, this.value)
          this.showList = true
        } else this.storeData = {}
    },
  },
  mounted() {
    //  let apiString = services.apiService(this.api.get, this.user.id, null)
    // this.getData(apiString)

    if (this.value !== null && Object.keys(this.value).length !== 0) {
      this.storeData = Object.assign({}, this.storeData, this.value)
      this.showList = true
    } else this.storeData = {}
  },
  beforeMount() {
    this.form = [
      {
        value: 'houseName',
        name: 'House name',
        typeComponent: 'FormBaseInputText',
        type: 'text',
        form: 'addresses',
        validation: { required: true },
        label: 'House/Flat Number or Name',
      },
      {
        value: 'streetName',
        name: 'Street name',
        typeComponent: 'FormBaseInputText',
        type: 'text',
        form: 'addresses',
        validation: { required: false },
        label: 'Street Name',
        options: { info: '(This field is optional)' },
      },
      {
        value: 'addressLine',
        name: 'Address line',
        typeComponent: 'FormBaseInputText',
        type: 'text',
        form: 'addresses',
        validation: { required: false },
        label: 'Address Line 1 ',
        options: { info: '(This field is optional)' },
      },
      {
        value: 'townCity',
        name: 'Town/City',
        typeComponent: 'FormBaseInputText',
        type: 'text',
        form: 'addresses',
        validation: { required: true },
        label: 'Town or City',
      },
      {
        value: 'county',
        name: 'County',
        typeComponent: 'FormBaseInputText',
        type: 'text',
        form: 'addresses',
        validation: { required: false },
        label: 'County',
        options: { info: '(This field is optional)' },
      },
      {
        value: 'postalCode',
        name: 'postcode',
        typeComponent: 'FormBaseInputText',
        type: 'text',
        form: 'addresses',
        validation: { required: true },
        label: 'Postcode',
      },
    ]
  },
  beforeDestroy() {
    var doc = this.$refs[this.name + 'address']
    if (doc !== undefined) doc.innerHTML = ''
  },
  methods: {
    distributionGroupsEndpoint(input) {
      return (
        'https://api.ideal-postcodes.co.uk/v1/postcodes/' +
        input +
        '?api_key=' +
        appConfig.apiAddressKey
      )
    },
    formattedDisplay(result) {
      // console.log(result)
      return (
        result.line_1 +
        ', ' +
        result.line_2 +
        ',' +
        result.post_town +
        ',' +
        result.county +
        ',' +
        result.postcode
      )
    },

    addDistributionGroup(group) {
      this.group = group

      this.address['houseName'] = group.selectedObject.line_1
      this.address['streetName'] = group.selectedObject.line_2
      this.address['addressLine'] = group.selectedObject.line_3
      this.address['townCity'] = group.selectedObject.post_town
      this.address['county'] = group.selectedObject.county
      this.address['postalCode'] = group.selectedObject.postcode
      this.storeData = Object.assign({}, this.storeData, this.address)
      // this.$emit('update', this.storeData)
      // access the autocomplete component methods from the parent
      //  this.$refs.autocomplete.clear()
    },

    deleteRecord() {
      this.storeData = null
      this.showList = false
      this.$emit('update', this.storeData)
    },
    sendData(event) {
      //    console.log(event)

      this.storeData[event.name] = event.data
      //  console.log(this.storeData)
    },
    openModal(name) {
      if (this.storeData === null) this.storeData = {}
      this.$bvModal.show(name)
    },
    saveData() {
      // var id = this.user.personalInfo.id
      //  console.log(name)

      // if (this.index === null) {
      this.$emit('update', this.storeData)
      this.hide(this.name)

      if (
        this.storeData.postalCode !== undefined &&
        this.storeData.postalCode !== null
      )
        this.showList = true

      /*  let api = services.apiService(this.api.post, this.user.id, null)
            this.postData(api) */
      /*  } else {
            let api = services.apiService(
              this.api.put,
              this.user.id,
              this.storeData['id']
            )
            this.putData(api, this.storeData['id'])
          } */
    },
    cancel(name) {
      this.hide(name)
    },
    hide(name) {
      this.$bvModal.hide(name)
      // this.storeData = {}
    },
  },
}
</script>
<template>
  <div :ref="name + 'address'">
    <div class="clear"></div>
    <div :class="$style.guideBoard" class="mt20 ">
      <span :class="$style.guideBoardIcon"></span>
      <p :class="$style.guideBoardText"
        ><b>Note : </b
        >{{ options.info !== undefined ? options.info : 'Address details' }}</p
      >
      <div class="clear"></div>
    </div>

    <div v-if="showList" :class="$style.addMainWraper">
      <label :class="$style.fieldTitle" class="w40 w100-sm FL pr15 pr0-sm">{{
        options.title
      }}</label>
      <div
        :class="[$style.addMoreWraper, $style.addmoreAddressWraper]"
        class="mt20"
      >
        <div
          v-b-toggle.accordion-1
          :class="$style.addMoreCardHeader"
          variant="info"
        >
          <h4 :class="$style.cardTitle" class="FL"
            >{{ storeData.houseName }}
          </h4>
          <div :class="$style.collapseActions" class="FR tc">
            <a
              id="edit"
              href="javascript:void(0)"
              :class="[$style.editCollapse, $style.collapseActionButton]"
              @click="openModal(name)"
              ><BIcon class="" icon="pencil" variant="outline-success"></BIcon>
              <b-tooltip target="edit" variant="secondary" placement="bottom"
                >Edit</b-tooltip
              >
            </a>
            <a
              id="delete"
              href="javascript:void(0)"
              :class="[$style.removeCollapse, $style.collapseActionButton]"
              @click="deleteRecord()"
              ><BIcon class="" icon="trash"></BIcon>
              <b-tooltip target="delete" variant="secondary" placement="bottom"
                >Delete</b-tooltip
              >
            </a>

            <a
              id="delete"
              href="javascript:void(0)"
              :class="[$style.removeCollapse, $style.collapseActionButton]"
              ><BIcon class="" icon="chevron-right"></BIcon>
            </a>
          </div>
          <div class="clear"></div>
        </div>
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
          <div :class="$style.addMoreCardBody">
            <p
              :class="[$style.cardData, $style.addressIcon]"
              class="FL mr20 pb10"
              >{{ storeData.houseName }}, {{ storeData.streetName }},
              {{ storeData.addressLine }} ,{{ storeData.county }},{{
                storeData.postcode
              }}
            </p>
            <p
              :class="[$style.cardData, $style.calendarIcon]"
              class="FL mr20 pb10"
              >{{ storeData.townCity }}
            </p>
          </div>
        </b-collapse>
      </div>
    </div>

    <div class="clear"></div>
    <a
      v-if="!showList"
      href="javascript:void(0)"
      :class="[$style.addMoreButton, $style.nameIcon]"
      class="FL d-block mt20"
      @click="openModal(name)"
      ><b>+</b>
      Add address
    </a>
    <div class="clear"></div>
    <div :class="$style.bodyContentBorder"></div>
    <div>
      <b-modal
        :id="name"
        centered
        title="BootstrapVue"
        hide-header
        hide-footer
        size="md"
      >
        <div :class="$style.modalWraper">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">Address</h3>
            <a
              href="javascript:void(0)"
              :class="$style.modalClose"
              @click="hide(name)"
              ><BIcon class="" icon="x" :class="$style.modalCloseIcon"></BIcon
            ></a>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <div :class="$style.autoCompleteWraper" class="p20">
              <Autocomplete
                ref="autocomplete"
                placeholder="Search Postcode"
                :source="distributionGroupsEndpoint"
                results-property="result"
                :results-display="formattedDisplay"
                name="postcodes"
                :show-no-results="false"
                input-class="autoComplete"
                @selected="addDistributionGroup"
              >
              </Autocomplete>
            </div>

            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <form
                :class="$style.form"
                @submit.prevent="handleSubmit(saveData)"
              >
                <FormBaseBuilder
                  :value="storeData"
                  :form="form"
                  :user="user"
                  @update="sendData"
                />

                <div class="clear"></div>
                <div :class="[$style.buttonWrapper]" class=" mt25 tc">
                  <button
                    type="button"
                    class="buttonCommon buttonCancel button mr20 mb20-xs"
                    @click="cancel(name)"
                  >
                    Cancel
                  </button>
                  <button
                    class="buttonCommon buttonPrimary button"
                    type="submit"
                    v-on="$listeners"
                  >
                    Update
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.autoCompleteWraper {
  background: #fafafa;
  border-radius: 10px;
}

.bodyContentBorder {
  width: 100%;
  height: 2px;
  margin: 30px 0;
  background: #f8f9f9;
}

// Instruction message
.guideBoard {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% + 60px);
  padding: 15px;
  margin-left: -30px;
  background: #fff5f1;

  .guideBoardIcon {
    position: relative;
    float: left;
    width: 45px;
    height: 45px;
    margin-right: 10px;
    background: #b9d3fa;
    border-radius: 50px;

    &::after {
      position: absolute;
      top: 0;
      left: 1px;
      width: 72px;
      height: 72px;
      content: '';
      background: url('~@assets/images/icon.png') no-repeat;
      background-position: 0 0;
      transform: scale(0.61);
      transform-origin: 0 0;
    }
  }

  .guideBoardText {
    float: left;
    width: calc(100% - 55px);
    margin: 8px 0 0;
    font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji;
    font-size: 12px;
    line-height: 16px;
    color: #757b82;
  }
}
// Instruction message

// Add more button
.addMoreButton {
  position: relative;
  padding: 2px 20px;
  font-family: 'LexendDecaRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 14px;
  line-height: 31px;
  color: #fff !important;
  text-decoration: none !important;
  background: #60e8bb;
  border: 1px solid #60e8bb;
  border-radius: 50px;
  transition: all ease-in-out 0.3s;

  &:hover {
    color: $color-main-button !important;
    background: #fff;
    border: 1px solid $color-main-button;
    transition: all ease-in-out 0.3s;
  }
}
// Add more button
// Add more wraper set
.addMainWraper {
  .addMoreWraper {
    position: relative;
    width: 90%;
    overflow: hidden;
    background: #fff;
    border: 1px solid #f2f2f2;
    border-radius: 10px;

    .addMoreCardHeader {
      position: relative;
      padding: 15px 15px 15px 35px;
      cursor: pointer;
      background: #fafafa;
      border-bottom: 1px solid #f2f2f2;

      &::after {
        position: absolute;
        top: 18px;
        left: 12px;
        width: 15px;
        height: 15px;
        content: '';
        background: #fdc360;
        border-radius: 50px;
      }
    }

    .addMoreCardBody {
      padding: 15px;
    }

    &.addmoreAddressWraper {
      .cardData {
        position: relative;
        padding-left: 20px;
        margin-bottom: 5px;
        font-family: 'RobotoRegular', Helvetica Neue, sans-serif,
          Apple Color Emoji;
        font-size: 12px;
        color: #6977a0;

        &::after {
          position: absolute;
          top: 4px;
          left: 0;
          width: 10px;
          height: 10px;
          content: '';
          background: #6e88b9;
          border-radius: 50px;
        }
      }
    }

    .collapseActions {
      .collapseActionButton {
        position: relative;
        display: inline-block;
        width: 23px;
        height: 23px;
        margin-right: 5px;
        font-size: 12px;
        color: #ff5c16 !important;
        background: #fff;
        border: 1px solid #fba47f;
        border-radius: 50px;
        transition: all 0.2s ease;

        &:hover {
          color: #fff !important;
          background: #ff5d15 !important;
          border-color: #ff5d15 !important;
          transition: all 0.2s ease;
        }
      }
      &:last-child {
        margin-right: 0 !important;
      }
    }

    .cardTitle {
      margin: 0;
      font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
      font-size: 15px;
      line-height: 20px;
      color: $color-field-text;
    }
  }
}
// Add more wraper set

.modalWraper {
  .modalHeader {
    padding: 25px 30px;
    background: #fafafa;
    border-bottom: 1px solid #ebebeb;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .modalTitle {
    float: left;
    margin: 5px 0 0 0;
    font-family: 'OpenSansRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    color: #808183;
  }

  .modalClose {
    position: relative;
    display: block;
    float: right;
    width: 32px;
    height: 32px;
    font-size: 23px;
    line-height: 30px;
    color: #8b8d90;
    text-align: center;
    background: #eceff1;
    border-radius: 50px;

    .modalCloseIcon {
      position: absolute;
      top: 4px;
      left: 5px;
    }
  }

  .modalBody {
    padding: 25px 30px 40px 30px;
  }

  .modalfooter {
    padding-top: 30px;
    padding-bottom: 10px;
  }
  .guideBoard {
    width: calc(100% + 80px);
    margin-left: -40px;
  }

  .formGroup {
    max-width: 100% !important;
  }
}
// Modal

@media (max-width: 767px) {
  .addMainWraper {
    .addMoreWraper {
      width: 100% !important;
    }
  }
}
</style>
